export { default } from "./ConsentManagerProvider";
export * from "./ConsentManagerProvider";
export * from "./ConsentManagerProvider.model";
